import { ApiRoute as apiRoute } from './Base.config';
const baseURL = process.env.REACT_APP_BASE_URL;
const apiAdminURL = process.env.REACT_APP_API_ADMIN_URL;
const apiOrderURL = process.env.REACT_APP_API_ORDER_URL;
const apiShipmentURL = process.env.REACT_APP_API_SHIPMENT_URL;
const apiQshipURL = process.env.REACT_APP_API_QSHIP_URL;
const apiTimeOut = Number(process.env.REACT_APP_API_TIMEOUT) || 60000;
const siteURL = process.env.REACT_APP_SITE_URL;
const mainSiteURL = process.env.REACT_APP_MAIN_SITE_URL;
const apiAuthURL = process.env.REACT_APP_API_AUTH_URL;


export {
  siteURL,
  mainSiteURL,
  baseURL,
  apiAdminURL,
  apiOrderURL,
  apiShipmentURL,
  apiQshipURL,
  apiTimeOut,
  apiRoute,
  apiAuthURL
};